
define('text!templates/modules/questionnaire/questionnaire-link-modal.html',[],function () { return '<div class="questionnaire-url">{{{url}}}</div>\n';});

